import { useCallback, useEffect, useState } from 'react';
import { getCurrentGame, startGame } from 'api';

// Loads and manages the current One Night Werewolf game state for a channel
// (whether one is in progress, and how many players are in it). Never carries
// any secret info (roles, etc.): that only ever reaches a player through their
// own secret chat with the Game Master. Re-fetches whenever the channel changes.
export const useGame = (channelId) => {
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    if (!channelId) {
      setGame(null);
      setLoading(false);
      setError(null);
      return undefined;
    }

    let active = true;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getCurrentGame(channelId);
        if (active) setGame(data);
      } catch (e) {
        if (active) setError(e.message);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [channelId]);

  const start = useCallback(async () => {
    setStarting(true);
    setError(null);
    try {
      const data = await startGame(channelId);
      setGame(data);
      return data;
    } catch (e) {
      setError(e.message);
      throw e;
    } finally {
      setStarting(false);
    }
  }, [channelId]);

  return { game, loading, error, starting, start };
};
